/* @jsxRuntime automatic */
import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import {
  NewAnalyticsBasePathContext,
  LegacyAnalyticsContext,
} from 'js/analytics/AnalyticsExperienceBoundary';
import { AnalyticsV2NavBar } from 'js/analytics_v2/AnalyticsV2NavBar';
import { analyticsTab, analyticsTabs } from 'js/analytics_v2/tabs';
import { trackAnalyticsClick } from 'js/analytics/metrics/analyticsTracking';

export const LegacyAnalyticsNavigation: React.FC<{
  premium: boolean;
  controls: React.ReactNode;
  children: React.ReactNode;
}> = ({ premium, controls, children }) => {
  const basePath = useContext(NewAnalyticsBasePathContext);
  const context = useContext(LegacyAnalyticsContext);
  const nonPremium = context ? context.access_mode === 'non_premium' : !premium;
  const location = useLocation();
  if (!basePath) return <>{children}</>;

  const active = analyticsTabs.find(
    ({ key }) => key === analyticsTab(location.pathname),
  );
  return (
    <AnalyticsV2NavBar
      activeItem={active?.label ?? 'Overview'}
      analyticsBasePath={basePath}
      controls={controls}
      nonPremium={nonPremium}
      onTabClick={(tab) =>
        trackAnalyticsClick('analytics-tab', {
          to_tab: tab,
          from_tab: analyticsTab(window.location.pathname),
          locked:
            nonPremium && ['readers', 'profile_visitors', 'cv'].includes(tab),
        })
      }
    />
  );
};
